import AreaPage from "./AreaPage";
import { NEWPORT_DATA } from "./areaData";

const NewportPage = () => <AreaPage {...NEWPORT_DATA} />;

export default NewportPage;
